export default function OtherSkills() {
  const redux = 50;
  const git = 80;
  const firebase = 80;
  const heroku = 80;
  const photoshop = 60;
  return (
    <>
      <div data-aos="fade-up" className="col-md-6 mb-3 col-sm-12 ">
        <div className="skill">
          <div className="d-flex align-items-center justify-content-between">
            <p>Redux</p>
            <h6>{redux}%</h6>
          </div>
          <div className="skillMeter" style={{ width: `${redux}%` }}></div>
        </div>
      </div>
      <div data-aos="fade-up" className="col-md-6 mb-3 col-sm-12 ">
        <div className="skill">
          <div className="d-flex align-items-center justify-content-between">
            <p>Git</p>
            <h6>{git}%</h6>
          </div>
          <div className="skillMeter" style={{ width: `${git}%` }}></div>
        </div>
      </div>
      <div data-aos="fade-up" className="col-md-6 mb-3 col-sm-12 ">
        <div className="skill">
          <div className="d-flex align-items-center justify-content-between">
            <p>Firebase</p>
            <h6>{firebase}%</h6>
          </div>
          <div className="skillMeter" style={{ width: `${firebase}%` }}></div>
        </div>
      </div>
      <div data-aos="fade-up" className="col-md-6 mb-3 col-sm-12 ">
        <div className="skill">
          <div className="d-flex align-items-center justify-content-between">
            <p>Heroku</p>
            <h6>{heroku}%</h6>
          </div>
          <div className="skillMeter" style={{ width: `${heroku}%` }}></div>
        </div>
      </div>
      <div data-aos="fade-up" className="col-md-6 mb-3 col-sm-12 ">
        <div className="skill">
          <div className="d-flex align-items-center justify-content-between">
            <p>Photoshop</p>
            <h6>{photoshop}%</h6>
          </div>
          <div className="skillMeter" style={{ width: `${photoshop}%` }}></div>
        </div>
      </div>
    </>
  );
}
